import {Authenticator} from './core.js';
import * as impl from '../auth/impl.js';
import * as api from '../../types/auth/api';

class CustomAuthenticator implements impl.AuthImpl {
    private readonly authFn: api.Authenticator;
    constructor(authFn: api.Authenticator) {
        this.authFn = authFn;
    }

    async auth(authenticationRequest: api.AuthenticationRequest): Promise<api.AuthenticationResponse> {
        const authenticationResponse = await this.authFn(authenticationRequest);
        return authenticationResponse;
    }
}
export function authenticator(config: impl.DefaultAuthenticatorConfig, authFn: api.Authenticator): Authenticator {
    return impl.authenticator(config, new CustomAuthenticator(authFn))
}
